import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import SubscribeForm from "./subscribe.form";
import styles from "./DynamicForm.module.scss"

export default function RenderForm({ event }: any) {
  const [searchParams] = useSearchParams();
  const emailFromQuery = searchParams.get("email") || "";

  const [values, setValues] = useState<any>({
    email: emailFromQuery,
    ...(emailFromQuery ? { terms: "true" } : {}),
  });

  useEffect(() => {
    if (!event.webinar.is_public) {
      setValues((prev: any) => ({ ...prev, access_code: "" }));
    }

  }, [event])


  const handleChange = (field: string, aditionalField?: string) => (e: any) => {
    setValues({ ...values, [field]: e.target.value, ...(aditionalField ? { [aditionalField]: e.target.value } : {}) });
  };


  return (
    <div className={styles.form_container}>

      <SubscribeForm {...{
        handleChange,
        values,
        event,
        autoSubscribe: !!emailFromQuery,
      }} />

    </div>
  )
}
